import React from "react";
import { Accordion } from "react-bootstrap";

const Alumni = () => {
  return (
    <div className='FAQBox'>
      <div className='FAQHeader'>
        <h3>Alumni Registration</h3>
      </div>
      <div className='AccordionBody'>
        <Accordion>
          <Accordion.Item eventKey='0'>
            <Accordion.Header>
              <h6 style={{ fontSize: "1.5rem" }}>Mission </h6>
            </Accordion.Header>

            <Accordion.Body style={{ textAlign: "justify" }}>
              <span>
                <br />
                Manipal University Jaipur Alumni Association registered under
                the Rajasthan Society Act 1958 on 24 August 2023.
                <br />
                <br />
                The mission of MUJAA is to create an association of the alumni
                of Manipal University Jaipur, for bringing together all the
                alumni of the Manipal University Jaipur so that it may create
                professional networking for mutual benefit in academic and
                professional or business areas. The mission of MUJAA is also to
                encourage alumni to contribute to the university’s efforts for
                achieving excellence in academics and research through
                allocating / raising funds and/or sharing knowledge & expertise
                of its members in areas pertaining to academics, infrastructure,
                industry interactions and any other area that the alumni and the
                university feel appropriate.
                <br />
                <br />
              </span>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey='1'>
            <Accordion.Header>
              <h6 style={{ fontSize: "1.5rem" }}>
                Link for Registration on MUJ Alumni Portal – Sign Up / Log In
              </h6>
            </Accordion.Header>
            <Accordion.Body>
              <div style={{ fontSize: "14px", lineHeight: "1.6" }}>
                <p style={{ marginBottom: "10px" }}>
                  <strong>MUJ Alumni Portal – </strong>
                  <a
                    href="https://mujalumni.in/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: "#2563eb",
                      textDecoration: "underline",
                      fontWeight: 600,
                    }}
                  >
                    https://mujalumni.in/
                  </a>
                </p>
                <ul style={{ paddingLeft: "20px", margin: 0 }}>
                  <li style={{ marginBottom: "6px" }}>
                    If you have already registered on the portal, please Sign In using your User ID and Password.
                  </li>
                  <li>
                    If you have not registered yet, please Sign Up/Register through the above link.
                  </li>
                </ul>
              </div>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey='2'>
            <Accordion.Header>
              <h6 style={{ fontSize: "1.5rem" }}>
                Payment for Lifetime/Annual Membership
              </h6>
            </Accordion.Header>
            <Accordion.Body>
              <div style={{ fontSize: "14px", lineHeight: "1.6" }}>
                <p style={{ margin: 0 }}>
                  After registration/sign-in, please click the “To Become a Member” tab, which is the first tab on the portal, to proceed with the payment for Lifetime/Annual Membership:{" "}
                  <a
                    href="https://mujalumni.in/account?redirect=https%253A%252F%252Fmujalumni.in%252Fmembership_list"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: "#2563eb",
                      textDecoration: "underline",
                      fontWeight: 600,
                    }}
                  >
                    Sign In / Sign Up
                  </a>
                </p>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
    </div>
  );
};

export default Alumni;
